// extracted by mini-css-extract-plugin
export default {"container":"TextLink_container__Br3ez"};